import { Injectable } from '@angular/core';
import { BaseNotifier } from '../../../../shared/notifiers/base-notifier';
import { Ref } from '../../../../shared/providers/ref';
import { MapProvider } from '../map/map-provider';
import { ZoomOutState } from './zoom-out-state';

@Injectable()
export class ZoomOutNotifier extends BaseNotifier<ZoomOutState> {
  private static readonly INITIAL: ZoomOutState = {};

  constructor(ref: Ref) {
    super(ref, ZoomOutNotifier.INITIAL);
  }

  zoomOut(): void {
    const view = this.ref.watch(MapProvider).state().view;
    if (!view) return;
    view.zoom -= 1;
  }
}
